import { render, staticRenderFns } from "./BalanceAmount.vue?vue&type=template&id=a288f6ac&scoped=true"
import script from "./BalanceAmount.vue?vue&type=script&lang=ts"
export * from "./BalanceAmount.vue?vue&type=script&lang=ts"
import style0 from "./BalanceAmount.vue?vue&type=style&index=0&id=a288f6ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a288f6ac",
  null
  
)

export default component.exports